import React, { useEffect, useState } from "react";
import { Grid } from "react-feather";
import { useParams } from "react-router-dom";
import Footer from "../footer";
import Header2 from "../header2/index-two";
import SubKatChard from "../sub/SubKatChard";
import axios from "axios";
import ProfKat from "../profkat/ProfKat";


export default function Subkat() {
  const {id} = useParams();
  const [subkat, setSubkat] = useState([])
  const [header, setHeader] = useState(null)
  const [loaded, setLoaded] = useState(false)
  const [parameter, setParameter] = useState([])
  const [countkat, setCountkat] = useState()
  const [countpar, setCountpar] = useState()

  useEffect(()=>{
    setLoaded(false)

    const getSubkat = async() =>{
      try {
        let res = await axios.get(`https://bbpom-makassar.com/api/sub-kategory/${id}`)
        setSubkat(res.data.data || [])
        setHeader(res.data.header)
        setParameter(res.data.par || [])
        setCountkat(res.data.countkat)
        setCountpar(res.data.countpar)
      } catch (e) {
        console.log(e.message)
        setHeader(null)
      } finally {
        setLoaded(true)
      }
    }

    getSubkat()
  },[id])



  console.log('hasil',header)
  return (
    <div className="main-wrapper">
      <Header2 
        activeMenu={"List"} 
      />
     

      {/* Page Wrapper */}
      <div className="page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* Filter */}
              <div className="showing-list">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="d-flex align-items-center">
                      <div className="view-icons">
                        
                        <span className="list-view active">
                          <Grid size={19} />
                        </span>
                      </div>
                      <div className="show-result">
                        <h4>Showing {countkat || 0} results</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Filter */}
              <div className="row">
                {loaded && !header ? (
                  <h5 style={{textAlign:'center'}}>Sub-kategori tidak ditemukan.</h5>
                ) : (
                  <ProfKat
                   header = {header}
                   countkat = {countkat}
                   countpar = {countpar}
                  />
                )}
              </div>
              <div className="row">
                {/* Instructor List */}
                <div className="col-lg-12">
                  <div className="student-grid-blk">
                  <div className="row">
                  {
                    subkat.map((sub,index)=>{
                      return(
                        <SubKatChard
                        key = {index}
                        title = {sub.nm_sub_kategory}
                        id= {sub.id}
                        header={header?.nm_kategory}
                        parameter={parameter[index]}
                        />
                      )})
                  }
                  </div>
                  </div>
                </div>
                {/* Instructor List */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Page Wrapper */}
      <Footer />
    </div>
  );
}
